import axios from "axios";
import { Alert } from "react-bootstrap";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  GET_USER_VENDOR_TEMPLATES_DETAILS,
  GET_SMS_TEMPLATES,
  GET_EMAIL_TEMPLATES,
  GET_NOTIFICATION_TEMPLATES,
  GET_IN_APP_TEMPLATES,
  GET_SINGLE_TEMPLATES,
  UPDATE_IN_APP_TEMPLATES,
  GET_VENDOR_TEMPLATES_DETAILS,
  GET_USER_TEMPLATES_DETAILS,
  EDIT_IN_APP_TEMPLATES,
} from "../../types";
import moment from "moment";
import { setErrors } from "../errorActions";

/***************************************
 * @DESC GET ALL USER AND VENDOR DATA
 ***************************************/
export const admin_get_user_vendor_info =
  (token, actionBy, source) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const get_user_vendor_info = await axios.get(
        `${serverApi}/${
          actionBy === "USER"
            ? "admin/user-service?users=true"
            : actionBy === "VENDOR"
            ? "admin/vendor-user"
            : ""
        }`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_user_vendor_info.status === 200) {
        if (source === 1) {
          if (actionBy === "USER") {
            dispatch({
              type: GET_USER_TEMPLATES_DETAILS,
              payload: get_user_vendor_info.data.users,
            });
          } else if (actionBy === "VENDOR") {
            dispatch({
              type: GET_VENDOR_TEMPLATES_DETAILS,
              payload: get_user_vendor_info.data,
            });
          }
        } else {
          dispatch({
            type: GET_USER_VENDOR_TEMPLATES_DETAILS,
            payload: get_user_vendor_info.data,
          });
        }
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_add_sms_email_template =
  (formData, token, actionBy, onSuccess) => async (dispatch) => {
    // console.log(formData, token, actionBy, onSuccess);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const add_faq = await axios.post(
        `${serverApi}/${
          actionBy === "SMS"
            ? `sms-template`
            : actionBy === "EMAIL"
            ? `email-template`
            : actionBy === "NOTIFICATION"
            ? `notification-template`
            : ``
        }`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (add_faq.status === 201) {
        if (actionBy === "SMS") {
          dispatch(
            admin_get_sms_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
          onSuccess();
        } else if (actionBy === "EMAIL") {
          dispatch(
            admin_get_email_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
          onSuccess();
        } else if (actionBy === "NOTIFICATION") {
          dispatch(
            admin_get_notification_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
          onSuccess();
        }
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC GET SMS TEMPLATES ACTION
 *********************************************/
export const admin_get_sms_templates_by_date =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_all_sms_templates = await axios.get(
        `${serverApi}/sms-template?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_all_sms_templates.status === 200) {
        dispatch({
          type: GET_SMS_TEMPLATES,
          payload: get_all_sms_templates.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC GET EMAIL TEMPLATES ACTION
 *********************************************/
export const admin_get_email_templates_by_date =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_all_email_templates = await axios.get(
        `${serverApi}/email-template?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_all_email_templates.status === 200) {
        dispatch({
          type: GET_EMAIL_TEMPLATES,
          payload: get_all_email_templates.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC GET NOTIFICATION TEMPLATES ACTION
 *********************************************/
export const admin_get_notification_templates_by_date =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const get_all_notification_templates = await axios.get(
        `${serverApi}/notification-template?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_all_notification_templates.status === 200) {
        dispatch({
          type: GET_NOTIFICATION_TEMPLATES,
          payload: get_all_notification_templates.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC GET IN APP TEMPLATES ACTION
 *********************************************/
export const admin_get_in_app_templates =
  (token, query) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const templates = await axios.get(`${serverApi}/inAppNotification`, {
        params: query,
        headers: { Authorization: token },
      });
      if (templates.status === 200) {
        dispatch({
          type: GET_IN_APP_TEMPLATES,
          payload: templates.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const add_in_app_templates =
  (token, data, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const templates = await axios.post(
        `${serverApi}/inAppNotification`,
        data,
        {
          headers: { Authorization: token },
        }
      );
      if (templates.status === 201) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      } else {
        Alert.error(`<h4>Something went Wrong, try again later</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_get_in_app_templates =
  (token, id, data, onSuccess, type) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const templates = await axios.patch(
        `${serverApi}/inAppNotification/${id}`,
        data,
        {
          headers: { Authorization: token },
        }
      );
      if (templates.status === 200) {
        onSuccess(templates.data);
        if(type === "edit"){
          dispatch({
            type: EDIT_IN_APP_TEMPLATES,
            payload: templates.data,
          });
        }else{
          dispatch({
            type: UPDATE_IN_APP_TEMPLATES,
            payload: templates.data,
          });
        }
       
        dispatch({ type: CLEAR_LOADER });
      } else {
        Alert.error(`<h4>Something went Wrong, try again later</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC UPDATE SMS TEMPLATES ACTION
 *********************************************/
export const admin_update_sms_templates =
  (smsTemplateId, token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const update_sms_by_templatesId = await axios.patch(
        `${serverApi}/sms-template/${smsTemplateId}`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (update_sms_by_templatesId.status === 200) {
        dispatch(
          admin_get_sms_templates_by_date(
            token,
            moment().format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          )
        );
        onSuccess(update_sms_by_templatesId.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC UPDATE EMAIL TEMPLATES ACTION
 *********************************************/
export const admin_update_email_templates =
  (emailTemplateId, token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const update_email_by_templatesId = await axios.patch(
        `${serverApi}/email-template/${emailTemplateId}`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (update_email_by_templatesId.status === 200) {
        dispatch(
          admin_get_email_templates_by_date(
            token,
            moment().format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          )
        );
        onSuccess(update_email_by_templatesId.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC UPDATE NOTIFICATION TEMPLATES ACTION
 *********************************************/
export const admin_update_notification_templates =
  (notificationTemplateId, token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const update_notification_by_templatesId = await axios.patch(
        `${serverApi}/notification-template/${notificationTemplateId}`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (update_notification_by_templatesId.status === 200) {
        onSuccess(update_notification_by_templatesId.data);
        dispatch(
          admin_get_notification_templates_by_date(
            token,
            moment.format("YYYY-MM-DD"),
            moment.format("YYYY-MM-DD")
          )
        );
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*********************************************
 * @DESC DELETE SMS - EMAIL - NOTIFICATION TEMPLATES ACTION
 *********************************************/
export const admin_delete_sms_email_notification_templates =
  (templateId, token, action, onSuccessDelete) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const delete_sms_templates = await axios.delete(
        `${serverApi}/${
          action === "SMS"
            ? `sms-template`
            : action === "EMAIL"
            ? `email-template`
            : action === "NOTIFICATION"
            ? `notification-template`
            : ``
        }/${templateId}`,
        {
          headers: { Authorization: token },
        }
      );
      if (delete_sms_templates.status === 200) {
        if (action === "SMS") {
          dispatch(
            admin_get_sms_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
        } else if (action === "EMAIL") {
          dispatch(
            admin_get_email_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
        } else if (action === "NOTIFICATION") {
          dispatch(
            admin_get_notification_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
        }
        onSuccessDelete();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************************************
 * @DESC UPDATE SEND APPROVEL SMS - EMAIL - NOTIFICATION TEMPLATES ACTION
 ************************************************************************/
export const admin_update_send_approval_templates =
  (templateId, token, action, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const apprroved_send_approval = await axios.patch(
        `${serverApi}/cron/${
          action === "SMS"
            ? `sms-template`
            : action === "EMAIL"
            ? `email-template`
            : action === "NOTIFICATION"
            ? `notification-template`
            : ``
        }/${templateId}?sendNow=true`,
        {
          headers: { Authorization: token },
        }
      );
      if (apprroved_send_approval.status === 200) {
        if (action === "SMS") {
          dispatch(
            admin_get_sms_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
        } else if (action === "EMAIL") {
          dispatch(
            admin_get_email_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
        } else if (action === "NOTIFICATION") {
          dispatch(
            admin_get_notification_templates_by_date(
              token,
              moment().format("YYYY-MM-DD"),
              moment().format("YYYY-MM-DD")
            )
          );
        }
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************************************
 * @DESC GET PERTICULAR SMS - EMAIL - NOTIFICATION TEMPLATES ACTION
 ************************************************************************/
export const admin_get_perticular_emailSMSNortification_templates =
  (templateId, token, action, onSuccessTemplates) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const admin_get_single_template = await axios.get(
        `${serverApi}/${
          action === "SMS"
            ? `sms-template`
            : action === "EMAIL"
            ? `email-template`
            : action === "NOTIFICATION"
            ? `notification-template`
            : ``
        }/${templateId}`,
        {
          headers: { Authorization: token },
        }
      );
      if (admin_get_single_template.status === 200) {
        dispatch({
          type: GET_SINGLE_TEMPLATES,
          payload: admin_get_single_template.data,
        });
        onSuccessTemplates();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
